import settings from '@/config/settings';

import type {IRequestSuccess} from '@/assets/core/assets/api/types';
import type {IUser, IUserShort, IUserUpdate} from '@/api/types/user';

import useAPIHook from '@/assets/core/assets/hooks/APIHook';

const url = new URL(settings.SERVICES.BASE.URL + '/users');

const useUserAPIHook = <TGetShort, TGet, TCreate, TUpdate>(baseUrl: URL) => {
  const api = useAPIHook<TGetShort, TGet, TCreate, TUpdate>(baseUrl);

  const getMe = async (): Promise<TGet> => await api.getOne('me');

  const sync = async (): Promise<IRequestSuccess> => {
    return await api.request.post(baseUrl.toString() + '/sync');
  };

  return {
    getMe,
    sync,

    ...api,
  };
};

export const userAPI = useUserAPIHook<IUserShort, IUser, unknown, IUserUpdate>(
  url,
);
